export const HEIGHT = window.screen.height;
export const WIDTH = window.screen.width;
